import React, { useEffect, useRef } from 'react';
import { Card, Col, Form, Row, Button } from 'react-bootstrap';
import { useFormContext } from 'react-hook-form';
import PropTypes from 'prop-types';
import { useState } from 'react';
import { useNavigate } from "react-router-dom";
import DatePicker from "react-datepicker";
import moment from "moment";
import axios from 'helpers/api';
import { toast } from 'react-toastify';
import { createIframeReportBlobUrl } from 'helpers/iframeReportPreview';
import AdvanceTablePagination from 'components/common/advance-table/AdvanceTablePagination';
import AdvanceTable from 'components/common/advance-table/AdvanceTable';
import useAdvanceTable from 'hooks/useAdvanceTable';
import AdvanceTableProvider from 'providers/AdvanceTableProvider';
import Spinner from 'react-bootstrap/Spinner';
import AdvanceTableSearchBox from 'components/common/advance-table/AdvanceTableSearchBox';
import AdvanceTableFooter from 'components/common/advance-table/AdvanceTableFooter';
import ShimmerUI from 'components/ShimmerUI/PatientShimmer';
import paths from 'routes/paths';
import { Link } from 'react-router-dom';

//const [medsheet, setMedSheet] = useState([]);

const DrugScheduleReport = (props) => {
    const [loader, setLoader] = useState(false);
    const [spinner, showSpinner] = useState(false);
    const [csvSpinner, showCsvSpinner] = useState(false);
    const [iframeSrc, setIframeSrc] = useState(null);
    const [tableData, setTableData] = useState([]);
    const [wholeData, setWholeData] = useState([]);
    const [drugSchedule, setDrugSchedule] = useState([]);
    const tableRef = useRef(null);
    const [formData, setFormData] = useState({
        isShowAllFacility: true,
        drug_schedule: 2
    })
    const facilityList = JSON.parse(localStorage.getItem("facilitiesData"));
    let facilityObj = facilityList.reduce((obj, item) => {
        obj[item.value] = item.key;
        return obj;
    }, {})
    const columns = [
        {
            accessorKey: 'facility_name',
            header: 'Facility Name',
            meta: {
                headerProps: { className: 'text-900 text-start' },
                cellProps: { className: 'text-start' }
            }
        },
        {
            accessorKey: 'patient_name',
            header: 'Patient Name',
            meta: {
                headerProps: { className: 'text-900 text-start' },
                cellProps: { className: 'text-start' }
            },
            cell: ({ row: { original } }) => {
                const patientDetails = paths.patientDetails;
                return (
                    <Link to={{ pathname: `${patientDetails}/${original.patient_id}` }}>
                        {original.patient_name}
                    </Link>
                )
            }
        },
        {
            accessorKey: 'drug',
            header: 'Drug',
            meta: {
                headerProps: { className: 'text-900 text-start' },
                cellProps: { className: 'text-start' }
            },
            cell: ({ row: { original } }) => {
                const editPrescription = paths.editPrescription;
                return (
                    <Link to={{ pathname: `${editPrescription}/${original.prescription_id}` }}>
                        {original.drug}
                    </Link>
                )
            }
        },
        {
            accessorKey: 'drugSchedule',
            header: 'Drug Schedule',
            meta: {
                headerProps: { className: 'text-900' },
            }
        },
        {
            accessorKey: 'last_dispensed_date',
            header: 'Last Dispensed Date',
            sortingFn: (rowA, rowB) => {
                const a = rowA.original.last_dispensed_date_raw
                    ? new Date(rowA.original.last_dispensed_date_raw)
                    : new Date(0);

                const b = rowB.original.last_dispensed_date_raw
                    ? new Date(rowB.original.last_dispensed_date_raw)
                    : new Date(0);

                return a - b; // latest first
            },
            meta: {
                headerProps: { className: 'text-900' },
            }
        },
        {
            accessorKey: 'hcp_name',
            header: 'HCP',
            meta: {
                headerProps: { className: 'text-900 text-start' },
                cellProps: { className: 'text-start' }
            }
        },
    ]

    useEffect(() => {
        if (!props.flag && props.selectedFacility != '') {
            fetchData()
        }
    }, [props.selectedFacility, formData.drug_schedule])


    useEffect(() => {
        setDrugSchedule([
            { "value": "", "label": "Select Drug Schedule" },
            { "value": "2", "label": "2" },
            { "value": "3", "label": "3" },
            { "value": "4", "label": "4" },
            { "value": "5", "label": "5" },
            { "value": "-999", "label": "Non Controlled" },
            { "value": "otc", "label": "OTC" },
        ])
    }, [])

    useEffect(() => {
        if (formData.isShowAllFacility) {
            fetchAllData();
        }
    }, [formData.drug_schedule])

    const fetchAllData = async () => {
        setWholeData([]);
        setLoader(true);
        let results = [];
        let pelmedsTreatmentUrl = `${process.env.REACT_APP_SERVER_URL}` + "/reports/drug-schedule-report";
        let pelmedsTreatmentData = {
            facility_id: '-999',
            drug_schedule: formData.drug_schedule,
            is_print: false
        };
        let tokenStr = localStorage.getItem("accessToken");
        try {
            const { data } = await axios.post(pelmedsTreatmentUrl, pelmedsTreatmentData, { headers: { 'Authorization': `Bearer ${tokenStr}` } });
            if (data.status == false) {
                toast.error(data.message);
            }
            data?.data?.drugs
                ?.sort((a, b) => {
                    const dateA = a.last_delivery_date ? new Date(a.last_delivery_date) : new Date(0);
                    const dateB = b.last_delivery_date ? new Date(b.last_delivery_date) : new Date(0);
                    return dateB - dateA; // latest first
                })
                ?.map((item, index) => {
                    results.push({
                        prescription_id: item.prescription_id,
                        patient_id: item.patient_id,
                        patient_name: (`${item.last_name}, ${item.first_name}`),
                        facility_name: facilityObj[item.facility_id],
                        drug: item.drug + " " + (item.strength_value ? item.strength_value : "") + " " + (item.strength ? item.strength : ""),
                        drugSchedule: [2, 3, 4, 5].includes(Number(item.drug_schedule))
                            ? `C${item.drug_schedule}`
                            : item.drug_subtype == 'O' ? 'OTC' : 'Not Controlled',
                        hcp_name: (`${item.doctor_firstname}, ${item.doctor_lastname}`),
                        last_dispensed_date: item.last_delivery_date ? moment(item.last_delivery_date).format("MM/DD/YY") : "Not Filled",
                        last_dispensed_date_raw: item.last_delivery_date || null
                    })
                })
            setWholeData(results);
            setFormData({ ...formData, isShowAllFacility: true });//default checked
            props.setFlag(true);
        }
        catch (error) {
            console.error("Error fetching data:", error);
            toast.error(data.message);
        } finally {
            setLoader(false);
        }
    }


    const fetchData = async () => {
        setLoader(true);
        let results = [];
        let pelmedsTreatmentUrl = `${process.env.REACT_APP_SERVER_URL}` + "/reports/drug-schedule-report";
        let pelmedsTreatmentData = {
            facility_id: props.selectedFacility,
            drug_schedule: formData.drug_schedule,
            is_print: false
        };
        let tokenStr = localStorage.getItem("accessToken");
        try {
            const { data } = await axios.post(pelmedsTreatmentUrl, pelmedsTreatmentData, { headers: { 'Authorization': `Bearer ${tokenStr}` } });
            if (data.status == false) {
                toast.error(data.message);
            }
            data?.data?.drugs?.sort((a, b) => {
                const dateA = a.last_delivery_date ? new Date(a.last_delivery_date) : new Date(0);
                const dateB = b.last_delivery_date ? new Date(b.last_delivery_date) : new Date(0);
                return dateB - dateA; // latest first
            }).map((item, index) => {
                results.push({
                    prescription_id: item.prescription_id,
                    patient_id: item.patient_id,
                    patient_name: (`${item.last_name},${item.first_name}`),
                    facility_name: facilityObj[item.facility_id],
                    drug: item.drug + " " + (item.strength_value ? item.strength_value : "") + " " + (item.strength ? item.strength : ""),
                    drugSchedule: [2, 3, 4, 5].includes(Number(item.drug_schedule))
                        ? `C${item.drug_schedule}`
                        : item.drug_subtype == 'O' ? 'OTC' : 'Not Controlled',
                    hcp_name: (`${item.doctor_firstname}, ${item.doctor_lastname}`),
                    last_dispensed_date: item.last_delivery_date ? moment(item.last_delivery_date).format("MM/DD/YY") : "Not Filled",
                    last_dispensed_date_raw: item.last_delivery_date || null
                })
            })
            setTableData(results);
            setLoader(false);
        } catch (error) {
            console.error("Error fetching data:", error);
        } finally {
            setLoader(false);
        }
    }

    const exportCSV = async e => {
        e.preventDefault();
        if (!props.validateFacility()) return;
        showCsvSpinner(true);

        let tokenStr = localStorage.getItem("accessToken");
        let pelmedsTreatmentUrl = `${process.env.REACT_APP_SERVER_URL}` + "/reports/drug-schedule-report";

        let pelmedsTreatmentData = {
            facility_id: formData.isShowAllFacility ? '-999' : localStorage.getItem("reportFacilityId"),
            drug_schedule: formData.drug_schedule,
            is_print: 'csv'
        };

        try {
            const response = await axios.post(pelmedsTreatmentUrl, pelmedsTreatmentData, {
                headers: { 'Authorization': `Bearer ${tokenStr}` },
                responseType: 'blob'
            });

            const disposition = response.headers['content-disposition'];
            const filename = disposition
                ? disposition.split('filename=')[1]?.replace(/"/g, '').trim()
                : 'drug-schedule-report.csv';

            const url = URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', filename);
            document.body.appendChild(link);
            link.click();

            link.parentNode.removeChild(link);
            URL.revokeObjectURL(url);

            toast.success("Drug Schedule Report Exported Successfully");
        } catch (error) {
            console.error("Error exporting CSV:", error);
            toast.error("Failed to export CSV report");
        } finally {
            showCsvSpinner(false);
        }
    };


    const handleSubmit = async e => {
        e.preventDefault();
        if (!props.validateFacility()) return;
        showSpinner(true);

        let tokenStr = localStorage.getItem("accessToken");
        let pelmedsTreatmentUrl = `${process.env.REACT_APP_SERVER_URL}` + "/reports/drug-schedule-report";

        let pelmedsTreatmentData = {
            facility_id: formData.isShowAllFacility ? '-999' : localStorage.getItem("reportFacilityId"),
            drug_schedule: formData.drug_schedule,
            is_print: true
        };

        const data = await axios.post(pelmedsTreatmentUrl, pelmedsTreatmentData, { headers: { 'Authorization': `Bearer ${tokenStr}` } });


        if (data.data.status == false) {
            toast.error(data.data.message);

        }
        else {
            toast.success("Drug Usage Report Generated Successfully");
            const { blobUrl } = await createIframeReportBlobUrl(data.data);
            setIframeSrc(blobUrl);
        }
        showSpinner(false);


    };

    const table = useAdvanceTable({
        data: tableData,
        columns,
        selection: false,
        sortable: true,
        pagination: true
    });

    const table2 = useAdvanceTable({
        data: wholeData,
        columns,
        selection: false,
        sortable: true,
        pagination: true
    });

    const tableHeight = tableRef.current ? tableRef.current.clientHeight : 0;
    const isDownloadDisabled =
        spinner ||
        (
            !formData.isShowAllFacility &&
            (props.selectedFacility === '' || tableData.length === 0)
        ) ||
        (
            formData.isShowAllFacility &&
            wholeData.length === 0
        );

    return (
        <div className="mt-4">
            <Form.Group>
                <Form.Label>Drug Schedule</Form.Label>
                <Form.Control
                    as="select"
                    name="drug_schedule"
                    value={formData.drug_schedule}
                    onChange={(e) => {
                        setFormData({ ...formData, drug_schedule: e.target.value })
                    }}
                >
                    {drugSchedule.map((facility) => (
                        <option key={facility.value} value={facility.value}>
                            {facility.label}
                        </option>
                    ))}
                </Form.Control>
            </Form.Group>
            <Form.Group className="mb-3">
                <Form.Check
                    type="checkbox"
                    label="All Facility"
                    name="isShowAllFacility"
                    onChange={(e) => {
                        props.setFlag(e.target.checked ? true : false);
                        setFormData({ ...formData, isShowAllFacility: e.target.checked ? true : false })
                    }
                    }
                    checked={formData.isShowAllFacility}
                />
            </Form.Group>
            {formData.isShowAllFacility == true ? <AdvanceTableProvider {...table2}>
                <Card className="mb-3 shadow-sm rounded-3">
                    <Card.Body className="p-4">
                        {loader ? <div className="d-flex justify-content-center align-items-center" style={{ height: `${tableHeight}px` }}>
                            <Spinner animation="border" role="status" className="mx-auto"></Spinner>
                        </div> : wholeData.length > 0 ? (
                            <Row>
                                <Col xs="4" className="mb-2 view-patient-search-holder">
                                    <AdvanceTableSearchBox placeholder="Search..." />
                                </Col>
                                <Col xs="12">
                                    <AdvanceTable
                                        headerClassName="bg-200 text-nowrap align-middle text-center fw-semibold"
                                        rowClassName="text-nowrap align-middle text-center"
                                        tableProps={{
                                            size: 'sm',
                                            striped: true,
                                            className: 'fs-12 mb-0 overflow-hidden table-bordered shadow-sm'
                                        }}
                                    />
                                </Col>
                            </Row>
                        ) : (
                            <div className="d-flex justify-content-center align-items-center text-center" style={{ height: '150px' }}>
                                <p className="text-danger fw-bold mb-0">No data available for this option. Please select another Facility.</p>
                            </div>
                        )}
                    </Card.Body>
                    <Card.Footer className="bg-light rounded-3 py-3">
                        <div className="mt-3">
                            <AdvanceTableFooter rowInfo navButtons rowsPerPageSelection />
                        </div>
                    </Card.Footer>
                </Card>
            </AdvanceTableProvider> :
                <AdvanceTableProvider {...table}>
                    <Card className="mb-3 shadow-sm rounded-3">
                        <Card.Body className="p-4">
                            {loader ? (
                                <div className="d-flex justify-content-center align-items-center" style={{ height: `${tableHeight}px` }}>
                                    <Spinner animation="border" role="status" className="mx-auto"></Spinner>
                                </div>
                            ) : tableData.length > 0 ? (
                                <Row>
                                    <Col xs="4" className="mb-2 view-patient-search-holder">
                                        <AdvanceTableSearchBox placeholder="Search..." />
                                    </Col>
                                    <Col xs="12">
                                        <AdvanceTable
                                            headerClassName="bg-200 text-nowrap align-middle text-center fw-semibold"
                                            rowClassName="text-nowrap align-middle text-center"
                                            tableProps={{
                                                size: 'sm',
                                                striped: true,
                                                className: 'fs-12 mb-0 overflow-hidden table-bordered shadow-sm'
                                            }}
                                        />
                                    </Col>
                                </Row>
                            ) : (
                                <div className="d-flex justify-content-center align-items-center text-center" style={{ height: '150px' }}>
                                    <p className="text-danger fw-bold mb-0">No data available for this option. Please select another Facility.</p>
                                </div>
                            )}
                        </Card.Body>
                        <Card.Footer className="bg-light rounded-3 py-3">
                            <div className="mt-3">
                                <AdvanceTableFooter rowInfo navButtons rowsPerPageSelection />
                            </div>
                        </Card.Footer>
                    </Card>
                </AdvanceTableProvider>}
            <Form onSubmit={handleSubmit}>
                <Row>
                    <Col xs={6} className="text-center">
                        {spinner ? (
                            <Button variant="primary" disabled className="mt-3 w-75 px-4 py-2">
                                <Spinner as="span" animation="grow" size="sm" role="status" aria-hidden="true" />
                                <span className="ms-2">Fetching...</span>
                            </Button>
                        ) : (
                            <Button disabled={isDownloadDisabled} type="submit" color="primary" className="mt-3 w-75 px-4 py-2">
                                Download Report
                            </Button>
                        )}
                    </Col>
                    <Col xs={6}>
                        {csvSpinner ? (
                            <Button variant="primary" disabled className="mt-3 w-75 px-4 py-2">
                                <Spinner as="span" animation="grow" size="sm" role="status" aria-hidden="true" />
                                <span className="ms-2">Fetching...</span>
                            </Button>
                        ) : (
                            <Button disabled={isDownloadDisabled} onClick={exportCSV} color="primary" className="mt-3 w-75 px-4 py-2">
                                Download CSV
                            </Button>
                        )}
                    </Col>
                </Row>
                <Row className="mt-3">
                    <Col>
                        <div style={{ height: 0, overflow: 'hidden' }}>
                            {iframeSrc && (
                                <iframe
                                    src={iframeSrc}
                                    style={{ width: "100%", height: "400px", border: "none", borderRadius: "8px" }}
                                    title="Preview Content"
                                />
                            )}
                        </div>
                    </Col>
                </Row>
                <Row className="mt-2">
                    <Col xs={12} className="text-end">
                        <Form.Label><span className="text-danger">*</span> indicates required field</Form.Label>
                    </Col>
                </Row>
            </Form>
        </div>

    );
};

DrugScheduleReport.propTypes = {
    layout: PropTypes.string,
    hasLabel: PropTypes.bool
};

DrugScheduleReport.defaultProps = {
    layout: 'simple',
    hasLabel: false
};

export default DrugScheduleReport;

